export enum EmploymentType {
FullTime,
PartTime,
Intermitting,
ByRotation,
Director,
Internship,
}
